import { render, staticRenderFns } from "./ChatPane.vue?vue&type=template&id=346187d3"
import script from "./ChatPane.vue?vue&type=script&lang=js"
export * from "./ChatPane.vue?vue&type=script&lang=js"
import style0 from "./ChatPane.vue?vue&type=style&index=0&id=346187d3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports